export default __webpack_public_path__ + "53e3fb737f62feef888dc7bcc6f4330b.png";